import React from "react";
import { Grid } from "@mui/material";
import useIsMobile from "../../shared_modules/useIsMobile";
import CalendarCard from "./calendarCard";
import AvailableTimes from "./availableTimes";

const SelectDateTime = ({
  barber,
  service,
  selectedDate,
  setSelectedDate,
  selectedSlot,
  setSelectedSlot,
}) => {
  const isMobile = useIsMobile();

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null); // clear slot when date changes
  };

  return (
    <Grid container spacing={2} sx={{ mt: 5 }}>
      <Grid size={isMobile ? 12 : 6}>
        <CalendarCard selected={selectedDate} setSelected={handleDateChange} />
      </Grid>
      <Grid size={isMobile ? 12 : 6}>
        <AvailableTimes
          barber={barber}
          service={service}
          selected={selectedDate}
          selectedSlot={selectedSlot}
          setSelectedSlot={setSelectedSlot}
        />
      </Grid>
    </Grid>
  );
};

export default SelectDateTime;
